import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, onMounted, watch } from 'vue'
import { findCusNameRelByPage as findCusNameRelByPageFbu } from '@/api/gucangSales/businessRuleSetting'
import { findCusNameRelByPage as findCusNameRelByPageOFbu } from '@/api/overseasSales/businessRuleSetting'
import { debounce } from 'lodash-es'
import { useI18n } from 'vue-i18n'
import type { PropType } from 'vue'
import type { SelectProps } from 'ant-design-vue'

const __default__ = { name: 'CusSelect' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  value: {
    type: String || Array
  },
  appId: {
    type: String as PropType<'cos_fbu' | 'cos_ofbu'>,
    required: true
  }
},
  emits: ['update:value', 'selectData'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

// 函数枚举对象
const findCusNameRelByPage = {
  cos_fbu: findCusNameRelByPageFbu,
  cos_ofbu: findCusNameRelByPageOFbu
}

const pageNumber = ref(1)
const data = ref()
const searchTxt = ref()
const emit = __emit
const optionPage = ref<any[]>([])
// 赋值
watch(
  () => props.value,
  (v, prev) => {
    if (v && v !== data.value) {
      data.value = v
      searchTxt.value = v
    } else if (!v) {
      data.value = undefined
    }
  },
  { immediate: true }
)
const change: SelectProps['onChange'] = (value) => {
  if (optionPage.value) {
    const arr = optionPage.value.filter((item) => item.arkCode === value)
    emit('selectData', arr[0].cosId)
  }
  emit('update:value', value)
}
const popupScroll = (e: any) => {
  const { scrollHeight, scrollTop, clientHeight } = e.target
  if (scrollHeight - scrollTop === clientHeight) {
    pageNumber.value = pageNumber.value + 1
    fetch()
  }
}
const search = debounce((txt: string) => {
  searchTxt.value = txt
  optionPage.value = []
  fetch()
}, 500)
// 获取公司下拉列表
const fetch = () => {
  findCusNameRelByPage[props.appId]({
    pageNumber: pageNumber.value,
    pageSize: 100,
    content: searchTxt.value
  }).then((res) => {
    optionPage.value = [...optionPage.value, ...res.data.items]
  })
}
onMounted(() => {
  fetch()
})

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    value: data.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
    style: {"width":"100%"},
    onPopupScroll: popupScroll,
    showSearch: true,
    "filter-option": false,
    onSearch: _unref(search),
    placeholder: _unref(t)('common.pleaseSelect'),
    onChange: change
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionPage.value, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: item.arkCode,
          cosId: item.customerName,
          value: item.arkCode
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.arkCode ? `${item.customerName}(${item.arkCode})` : item.customerName), 1)
          ]),
          _: 2
        }, 1032, ["cosId", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "onSearch", "placeholder"]))
}
}

})